import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError, tap, map } from 'rxjs';

import { environment } from '../../environments/environment';
import { NotificationService } from './notification.service';
import { Discipline } from '../models/discipline';
import { DisciplineSearch } from '../models/disciplineSearch';
import { Store } from '@ngrx/store';
import { cleanSearchParams, handleError } from '../shared/helper/helpers-functions';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class DisciplineService {
  private url = environment.pvtUrl;

  constructor(
    private http: HttpClient,
    private notificationService: NotificationService,
    private store: Store
  ) {}

  private log(message: string) {
    console.log(message);
  }

  getAllDisciplines(): Observable<Discipline[]> {
    const url = `${this.url}/disciplines/all`;
    return this.http.get<Discipline[]>(url).pipe(
      tap((_) => this.log(`getAllDisciplines`)),
      catchError(handleError<Discipline[]>(`getDisciplines`, this.notificationService, this.store))
    );
  }

  searchPaginatedDisciplines(
    discipinesSearch: DisciplineSearch
  ): Observable<DisciplineSearch> {
    const url = `${this.url}/disciplines/search22`;
    return this.http
      .post<DisciplineSearch>(
        url,
        cleanSearchParams(discipinesSearch),
        httpOptions
      )
      .pipe(
        tap((_) => this.log(`searchPaginatedDisciplines`)),
        catchError(handleError<DisciplineSearch>(`searchPaginatedDisciplines`, this.notificationService, this.store))
      );
  }

  searchDisciplines(
    disciplineSearch: DisciplineSearch
  ): Observable<Discipline[]> {
    const url = `${this.url}/disciplines/search`;
    return this.http
      .post<Discipline[]>(
        url,
        cleanSearchParams(disciplineSearch),
        httpOptions
      )
      .pipe(
        map((disciplines: Discipline[]) =>
          this.addConcernsFlag<Discipline>(disciplines)
        ),
        tap((_) => this.log(`searchDisciplines`)),
        catchError(handleError<Discipline[]>(`searchDisciplines`, this.notificationService, this.store))
      );
  }

  searchDisciplines2(
    disciplinesSearch: DisciplineSearch
  ): Observable<DisciplineSearch> {
    const url = `${this.url}/disciplines/search2`;
    return this.http
      .post<DisciplineSearch>(url, disciplinesSearch, httpOptions)
      .pipe(
        tap((_) => this.log(`searchDisciplines2`)),
        catchError(handleError<DisciplineSearch>(`searchDisciplines2`, this.notificationService, this.store))
      );
  }

  getDisciplineSearch(): Observable<DisciplineSearch> {
    const url = `${this.url}/disciplines/disciplineSearch`;
    return this.http.get<DisciplineSearch>(url, httpOptions).pipe(
      tap((_) => this.log(`getDisciplineSearch`)),
      catchError(handleError<DisciplineSearch>(`getDisciplineSearch`, this.notificationService, this.store))
    );
  }

  private addConcernsFlag<T extends { documents?: any[] }>(results: T[]): T[] {
    if (!Array.isArray(results) || results.length == 0) {
      return [];
    }

    return results.map((result) => ({
      ...result,
      hasConcerns: result.documents?.length > 0 || false,
      hasConcernsString: result.documents?.length > 0 ? 'concerns' : '',
    }));
  }
}
